import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./style.css";
import TransactionModal from "./Transection_modal";
import { useState } from "react";
import Walletsidebar from "../../../components/Wallet_sidebar";
import { images } from "../../../constants/index";
import { useNavigate } from "react-router-dom";
const Portfolio = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  return (
    <Row>
      <div className="screenHeight d-flex justify-content-around align-items-center p-3">
        <Col
          lg="2"
          className="bg-white shadow-sm h-100 rounded"
          style={{ border: "1px solid #0353a4" }}
        >
          <Walletsidebar />
        </Col>

        <Col lg="8" className="h-100">
          <Container fluid className="portfolio-container b-radius shadow">
            <TransactionModal
              show={showModal}
              handleClose={() => setShowModal(false)}
            />
            {/* Header Section */}
            <Row className="justify-content-between align-items-center p-3">
              <Col xs="auto">
                <h3 className="portfolio-title">Portfolio</h3>
              </Col>
              <Col xs="auto">
                <a
                  href="#"
                  className="transaction-link font_13"
                  onClick={() => setShowModal(true)}
                >
                  View Transaction History
                </a>
              </Col>
            </Row>

            {/* Investment Details */}
            <Row className="px-3">
              <Col xs={12}>
                <h5 className="investment-title">Investments Details</h5>
              </Col>
            </Row>

            {/* Card Section */}
            <Row className="p-3">
              <Col xs={12} md={6} lg={7}>
                <Card className="investment-card">
                  <Row>
                    <Col xs={5}>
                      <Card.Img
                      className="card-image"
                        variant="top"
                        src={images.Wallet1}
                      />
                    </Col>
                    <Col
                      xs={7}
                      className="d-flex flex-column justify-content-center"
                    >
                      <Card.Body>
                        <Card.Text className="mb-0 pb-0">
                          <strong>Wallet #:</strong> 1
                        </Card.Text>
                        <Card.Text className="mb-0 pb-0">
                          <strong>Project Name:</strong>
                          <a href="#">Selectezi</a>
                        </Card.Text>
                        <Card.Text className="mb-0 pb-0">
                          <strong>Total Investment:</strong> R$ 2,000
                        </Card.Text>
                        <Button className="mt-4 b-radius" variant="primary" size="sm" onClick={()=>navigate("/investment-details")}>
                          View Details
                        </Button>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
        </Col>
      </div>
    </Row>
  );
};

export default Portfolio;
